import { render, staticRenderFns } from "./RightGroupForm.vue?vue&type=template&id=37755b0b"
import script from "./RightGroupForm.vue?vue&type=script&lang=js"
export * from "./RightGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports